module.exports = __webpack_public_path__ + "iStock-1028462780.png?e5d25dc1a00cc64fe6e10c0477bc2d2f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iStock-1028462780.png
// module id = 203
// module chunks = 0